var map = {
	"./AMONG US.png": 14,
	"./APEX LEGENDS.png": 7201,
	"./DOTA 2.png": 8431,
	"./FIFA.png": 4381,
	"./FORTNITE.png": 8135,
	"./LEAGUE OF LEGENDS.png": 9894,
	"./OVERWATCH.png": 8270,
	"./PUBG.png": 86,
	"./VALORANT.png": 3415,
	"./WORLD OF WARCRAFT.png": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4548;